// src/modules/units/tyres/shared/retread-batch-access.js
//
// Who may change a retread batch. The backend gates create / dispatch / receive /
// cancel / rollback to administrators; the list and detail GETs are open to every
// portal user. This helper only decides whether to SHOW the write controls, so a
// standard user isn't offered buttons that would 403.
//
// It is a UI affordance, not the security boundary: the server stays the
// authority, and every write still surfaces a clear "administrator access needed"
// message if this check is ever wrong (see the forms). Batch management is
// intentionally administrator-only for now (confirmed), so a plain userRole check
// is all this needs; widen this one function if that policy ever changes.

import { getUserData } from '../../../auth/views/login/auth.api.js';

export function canManageBatches() {
  return getUserData()?.userRole === 'Administrator';
}
